import { useContext, useState, useEffect } from 'react';
import { AdminUsersDataContext } from '../../contexts/AdminUsersDataContext';import UserService from '../../services/UserService';
import { iUser } from '../../contexts/UserContext';
import userService from '../../services/UserService';
import DashboardCenterSettings from '../DashboardCenterSettings';
import { BackToUsersLink } from  '../AdminCenterUsers';

export default function  UserEdit(){
    const [user,setUser] = useState<iUser | null | undefined>(null);
    const {studentUser, isStudentUsersDataLoaded, selectedUserType} = useContext(AdminUsersDataContext);

    useEffect(() => {
        fetchUser();
    }, [studentUser, isStudentUsersDataLoaded]);
    
    const fetchUser = async () => {
        if(studentUser?.authId){
            await userService.GetUser(studentUser?.authId, (v) => { }, true).then((result) => {
                setUser(userService.MapToUser(result));
            })
        }
    }
    
    return (
        <div>
            <BackToUsersLink />
            {studentUser && <DashboardCenterSettings isAdminEdit={true} user={user} updateUser={(user) => { setUser(userService.MapToUser(user)) }} selectedUserType={selectedUserType} isReadOnly={false}/>}
        </div>
    )
}